import Layout from '../components/layout/Layout';
import SectionLabel from '../components/shared/SectionLabel';
import SEO from '../components/shared/SEO';
import '../styles/privacypolicy.css';

const sections = [
  {
    id: 'introduction',
    number: '01',
    heading: 'Privacy Policy',
    body: (
      <>
        <p>
          At apexdefilabs.com, accessible from https://apexdefilabs.com/, one of our main priorities is the
          privacy of our visitors. This Privacy Policy document contains types of information that is
          collected and recorded by apexdefilabs.com and how we use it.
        </p>
        <p>
          If you have additional questions or require more information about our Privacy Policy, do not
          hesitate to contact us. Our Privacy Policy was created with the help of the Privacy Policy
          Generator.
        </p>
      </>
    ),
  },
  {
    id: 'log-files',
    number: '02',
    heading: 'Log Files',
    body: (
      <p>
        apexdefilabs.com follows a standard procedure of using log files. These files log visitors when they
        visit websites. All hosting companies do this and a part of hosting services' analytics. The
        information collected by log files include internet protocol (IP) addresses, browser type, Internet
        Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of
        clicks. These are not linked to any information that is personally identifiable. The purpose of the
        information is for analyzing trends, administering the site, tracking users' movement on the
        website, and gathering demographic information.
      </p>
    ),
  },
  {
    id: 'cookies',
    number: '03',
    heading: 'Cookies and Web Beacons',
    body: (
      <>
        <p>
          Like any other website, apexdefilabs.com uses 'cookies'. These cookies are used to store
          information including visitors' preferences, and the pages on the website that the visitor
          accessed or visited. The information is used to optimize the users' experience by customizing our
          web page content based on visitors' browser type and/or other information.
        </p>
        <p>
          For more general information on cookies, please read "Cookies" article from the Privacy Policy
          Generator.
        </p>
      </>
    ),
  },
  {
    id: 'dart-cookie',
    number: '04',
    heading: 'Google DoubleClick DART Cookie',
    body: (
      <p>
        Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to
        serve ads to our site visitors based upon their visit to www.website.com and other sites on the
        internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad
        and content network Privacy Policy at the following URL –{' '}
        <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer">
          https://policies.google.com/technologies/ads
        </a>
      </p>
    ),
  },
  {
    id: 'advertising-partners',
    number: '05',
    heading: 'Our Advertising Partners',
    body: (
      <>
        <p>
          Some of advertisers on our site may use cookies and web beacons. Our advertising partners are
          listed below. Each of our advertising partners has their own Privacy Policy for their policies on
          user data. For easier access, we hyperlinked to their Privacy Policies below.
        </p>
        <ul>
          <li>
            Google –{' '}
            <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer">
              https://policies.google.com/technologies/ads
            </a>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 'privacy-policies',
    number: '06',
    heading: 'Privacy Policies',
    body: (
      <p>
        You may consult this list to find the Privacy Policy for each of the advertising partners of
        apexdefilabs.com. Third-party ad servers or ad networks uses technologies like cookies, JavaScript,
        or Web Beacons that are used in their respective advertisements and links that appear on
        apexdefilabs.com, which are sent directly to users' browser. They automatically receive your IP
        address when this occurs. These technologies are used to measure the effectiveness of their
        advertising campaigns and/or to personalize the advertising content that you see on websites that
        you visit. Note that apexdefilabs.com has no access to or control over these cookies that are used
        by third-party advertisers.
      </p>
    ),
  },
  {
    id: 'third-party-policies',
    number: '07',
    heading: 'Third Party Privacy Policies',
    body: (
      <p>
        apexdefilabs.com's Privacy Policy does not apply to other advertisers or websites. Thus, we are
        advising you to consult the respective Privacy Policies of these third-party ad servers for more
        detailed information. It may include their practices and instructions about how to opt-out of
        certain options. You can choose to disable cookies through your individual browser options. To know
        more detailed information about cookie management with specific web browsers, it can be found at the
        browsers' respective websites. What Are Cookies?
      </p>
    ),
  },
  {
    id: 'childrens-information',
    number: '08',
    heading: "Children's Information",
    body: (
      <>
        <p>
          Another part of our priority is adding protection for children while using the internet. We
          encourage parents and guardians to observe, participate in, and/or monitor and guide their online
          activity.
        </p>
        <p>
          apexdefilabs.com does not knowingly collect any Personal Identifiable Information from children
          under the age of 13. If you think that your child provided this kind of information on our
          website, we strongly encourage you to contact us immediately and we will do our best efforts to
          promptly remove such information from our records.
        </p>
      </>
    ),
  },
  {
    id: 'online-privacy-policy',
    number: '09',
    heading: 'Online Privacy Policy Only',
    body: (
      <p>
        This Privacy Policy applies only to our online activities and is valid for visitors to our website
        with regards to the information that they shared and/or collect in apexdefilabs.com. This policy is
        not applicable to any information collected offline or via channels other than this website.
      </p>
    ),
  },
  {
    id: 'consent',
    number: '10',
    heading: 'Consent',
    body: (
      <p>
        By using our website, you hereby consent to our Privacy Policy and agree to its Terms and
        Conditions.
      </p>
    ),
  },
];

const tocLinks = [
  { label: 'Privacy Policy', id: 'introduction' },
  { label: 'Log Files', id: 'log-files' },
  { label: 'Cookies and Web Beacons', id: 'cookies' },
  { label: 'Google DART Cookie', id: 'dart-cookie' },
  { label: 'Advertising Partners', id: 'advertising-partners' },
  { label: 'Privacy Policies', id: 'privacy-policies' },
  { label: 'Third Party Policies', id: 'third-party-policies' },
  { label: "Children's Information", id: 'childrens-information' },
  { label: 'Online Privacy Policy', id: 'online-privacy-policy' },
  { label: 'Consent', id: 'consent' },
];

export default function PrivacyPolicyPage() {
  return (
    <Layout>
      <SEO
        title="Privacy Policy - Apex DeFi Labs"
        description="Read the Apex DeFi Labs privacy policy. Learn how we collect, use, and protect your information on apexdefilabs.com."
        url="https://apexdefilabs.com/privacy-policy"
        type="website"
        keywords="Apex DeFi Labs privacy policy, data privacy, cookies policy"
      />

      <div className="privacy-page">
        {/* Hero */}
        <section className="privacy-hero">
          <div className="privacy-hero-overlay" />
          <div className="privacy-shell">
            <div style={{ marginBottom: '1.2rem' }}>
              <SectionLabel>Legal</SectionLabel>
            </div>
            <h1 className="privacy-hero-title">
              Privacy <em>Policy</em>
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="privacy-content">
          <div className="privacy-shell">
            {/* Table of Contents */}
            <nav className="privacy-toc" aria-label="Table of contents">
              <div className="privacy-toc-title">Contents</div>
              <ol className="privacy-toc-list">
                {tocLinks.map((item) => (
                  <li key={item.id}>
                    <a href={`#${item.id}`}>{item.label}</a>
                  </li>
                ))}
              </ol>
            </nav>

            {/* Sections */}
            {sections.map((section) => (
              <article key={section.id} id={section.id} className="privacy-section">
                <span className="privacy-section-number">{section.number}</span>
                <h2 className="privacy-section-heading">{section.heading}</h2>
                <div className="privacy-section-body">{section.body}</div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </Layout>
  );
}
